import { ASSET_STATUS, IAsset } from '@desp-aas/desp-ui-fwk';
import { useMemo } from 'react';
import { assetStatusIcon, assetStatusLabel } from '../../utils/assets';


type IProps = {
    asset: IAsset|undefined
    editMode: boolean
    isOwner: boolean
}

export const AssetStatus = (props: IProps) => {

    const showStatus = useMemo(() => {
        return (
            !props.editMode && props.isOwner && 
            props.asset?.status && (
                props.asset?.status !== ASSET_STATUS.published
            )
        )
    }, [ props.editMode, props.isOwner, props.asset, props.asset?.status ]);

    const statusLabel = useMemo(() => {
        return props.asset?.status ? assetStatusLabel(props.asset?.status) : undefined;
    }, [ props.asset?.status ]);

    const statusIcon = useMemo(() => {
        return props.asset?.status ? assetStatusIcon(props.asset?.status) : undefined;
    }, [ props.asset?.status ]);

    if(!showStatus) return null;


    

    return <>
        <div id="asset-status-next-update">
            The latest version is:
        </div>
        <div id="asset-status-tag" className={`status-${props.asset?.status?.toLowerCase()}`}>
            { statusIcon } { statusLabel }
        </div>
    </> 
}